<div [formGroup]="form" class="options">

    <div formArrayName="options">

        <div *ngFor="let option of options; let i=index" class="options__item mb-4" data-test="questionAnswer">

            <!-- option number -->
            <div class="mr-2">
                <app-view-quiz-answer-number [number]="i + 1"></app-view-quiz-answer-number>
            </div>

            <!-- option text -->
            <div class="options__item-select">
                <app-quiz-label-anatomy-select [options]="options" [formControlName]="i">
                </app-quiz-label-anatomy-select>
            </div>

        </div>
    </div>

</div>